// Components==============
import Button from 'components/UI/Button';
import Container from 'components/UI/Container';
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { NavLink } from 'react-router-dom';
import { contactTextValues } from 'utilities/contactTextValues';
import { GlobalContext } from 'utilities/GlobalContextWrapper';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import NewsModal from './components/NewsModal';
import './index.module.scss';
// =========================

export default function Footer() {
    const { setContactText } = useContext(GlobalContext);

    const openContactModal = useOpenUrlModal('contact-popup');
    const openNewsModal = useOpenUrlModal('nieuwsbrief-popup');

    const history = useHistory();

    return (
        <>
            <div styleName="background">
                <Container>
                    <div styleName="grid">
                        <div styleName="area1">
                            <p>NXT is een initiatief van</p>
                            <img
                                src="/images/LogoORBO_FC.svg"
                                alt="Orbo logo"
                                styleName="orbo"
                            />
                            {/* <img
                                src="/images/logo-with-text.svg"
                                alt="Orion logo"
                            />
                            <img src="/images/omo_logo.svg" alt="Omo logo" /> */}
                        </div>
                        <div styleName="area2">
                            <p styleName="heading">Socials</p>
                            <Button
                                onClick={() => {
                                    openNewsModal();
                                }}
                            >
                                Nieuwsbrief
                            </Button>
                            <div styleName="social-media">
                                <motion.a
                                    href="https://www.linkedin.com/company/ontwikkelplatform-nxt"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    initial={{ scale: 1 }}
                                >
                                    <img
                                        src="/images/linkedIn.png"
                                        alt="LinkedIn"
                                    />
                                </motion.a>
                                <motion.a
                                    href="https://www.youtube.com/@ontwikkelplatformNXT"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    initial={{ scale: 1 }}
                                >
                                    <img
                                        src="/images/YouTube.png"
                                        alt="Youtube"
                                    />
                                </motion.a>
                                <motion.a
                                    href="https://www.facebook.com/nxtontwikkelplatform"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    initial={{ scale: 1 }}
                                >
                                    <img
                                        src="/images/Facebook.png"
                                        alt="Facebook"
                                    />
                                </motion.a>
                                <motion.a
                                    href="https://www.instagram.com/ontwikkelplatform__nxt"
                                    target="_blank"
                                    rel="noreferrer"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    initial={{ scale: 1 }}
                                >
                                    <img
                                        src="/images/Instagram.png"
                                        alt="Instagram"
                                    />
                                </motion.a>
                            </div>
                        </div>
                        <div styleName="area3">
                            <p styleName="heading">Vragen?</p>
                            <Button
                                onClick={() => {
                                    setContactText(contactTextValues.contact);
                                    openContactModal();
                                }}
                            >
                                Contact
                            </Button>
                            <NavLink to="/disclaimer">Disclaimer</NavLink>
                            <NavLink to="/privacy">Privacy statement</NavLink>
                        </div>
                        <div styleName="area4">
                            <p styleName="heading">Stap in de wereld van NXT</p>
                            <Button onClick={() => history.push('/over-nxt')}>
                                Over NXT
                            </Button>
                        </div>
                    </div>
                </Container>
            </div>
            <NewsModal />
        </>
    );
}
